import { Staff } from "./Staff.type";
import apiClient from "../../../shared/utils/apiClient";

const API_URL = "/Staffs";

export const getStaffs = async () => {
  try {
    const response = await apiClient.get<Staff[]>(API_URL);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error fetching staff: ${error.message}`);
  }
};

export const addStaff = async (staff: Staff) => {
  try {
    const response = await apiClient.post<Staff>(API_URL, staff);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error adding staff: ${error.message}`);
  }
};

export const updateStaff = async (staff: Staff) => {
  try {
    const response = await apiClient.put<Staff>(API_URL, staff);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error updating staff: ${error.message}`);
  }
};

export const deleteStaff = async (staffId: number) => {
  try {
    await apiClient.delete(`${API_URL}/${staffId}`);
  } catch (error: any) {
    throw new Error(`Error deleting staff: ${error.message}`);
  }
};
